import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useMemo, useEffect } from "react";
import AntSlider from "antd/es/slider";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import Row from "../Grid/Row.js";
import './RangeSlider.css';import '../Grid/Grid.css';/* empty css                */
import InputNumber from "../InputNumber/InputNumber.js";
import Typography from "../Typography/Typography.js";
/* empty css                 */
const DEFAULT_LABEL_FORMATTER = (value) => value;
const RangeSlider = ({
  value: propsValue,
  vertical,
  className,
  classNameWrapper,
  classNameHeader,
  onChange,
  min = 0,
  max = Number.MAX_SAFE_INTEGER,
  minLabel = "От",
  maxLabel = "до",
  tooltip,
  labelFormatter = DEFAULT_LABEL_FORMATTER,
  valueFormatter,
  valueParser,
  headerDisplayType = "text",
  ...props
}) => {
  const [value, setValue] = useState(propsValue);
  const {
    open: tooltipOpen = false,
    placement: tooltipPlacement = !vertical ? "bottom" : "right",
    ...tooltipProps
  } = tooltip || {};
  const resolvedTooltip = useMemo(() => {
    return {
      open: tooltipOpen,
      placement: tooltipPlacement,
      className: classnames("perxis-auto-slider-tooltip"),
      ...tooltipProps
    };
  }, [tooltipOpen, tooltipPlacement, tooltipProps]);
  const defaultValue = useMemo(() => {
    if (!propsValue) {
      return [min, max];
    }
    return propsValue;
  }, [propsValue, min, max]);
  const resolvedValue = useMemo(() => {
    if (!value) {
      return defaultValue;
    }
    return value;
  }, [value, defaultValue]);
  const handleChange = (newValue) => {
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  const renderHeader = () => {
    switch (headerDisplayType) {
      case "text": {
        return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-range-slider-header", classNameHeader), children: [
          /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-range-slider-header__min"), children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", children: `${minLabel} ${labelFormatter(resolvedValue[0])}` }) }),
          /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-range-slider-header__max"), children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", children: `${maxLabel} ${labelFormatter(resolvedValue[1])}` }) })
        ] });
      }
      case "input": {
        return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-range-slider-header", classNameHeader), children: [
          /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-range-slider-header__min"), children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], children: [
            /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", children: `${minLabel}` }) }),
            /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(
              InputNumber,
              {
                value: resolvedValue[0],
                min,
                max: resolvedValue[1],
                controls: false,
                placeholder: (valueFormatter == null ? void 0 : valueFormatter(min, {
                  userTyping: false,
                  input: `${min}`
                })) ?? `${min}`,
                parser: valueParser,
                formatter: valueFormatter,
                onChange: (v) => handleChange([v || min, resolvedValue[1]])
              }
            ) })
          ] }) }),
          /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-range-slider-header__max"), children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], children: [
            /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", children: `${maxLabel}` }) }),
            /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(
              InputNumber,
              {
                value: resolvedValue[1],
                min: resolvedValue[0],
                max,
                controls: false,
                placeholder: (valueFormatter == null ? void 0 : valueFormatter(max, {
                  userTyping: false,
                  input: `${max}`
                })) ?? `${max}`,
                parser: valueParser,
                formatter: valueFormatter,
                onChange: (v) => handleChange([resolvedValue[0], v || max])
              }
            ) })
          ] }) })
        ] });
      }
      default:
        return null;
    }
  };
  useEffect(() => {
    setValue(propsValue);
  }, [propsValue]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classnames(
        [
          "perxis-auto-range-slider-wrapper",
          {
            "perxis-auto-range-slider-wrapper--vertical": vertical,
            [`perxis-auto-range-slider-wrapper--${headerDisplayType || "no-header"}`]: true
          }
        ],
        classNameWrapper
      ),
      children: [
        renderHeader(),
        /* @__PURE__ */ jsx(
          AntSlider,
          {
            range: true,
            min,
            max,
            value: resolvedValue,
            className: classnames("perxis-auto-range-slider", className),
            vertical,
            tooltip: resolvedTooltip,
            onChange: handleChange,
            ...props
          }
        )
      ]
    }
  );
};
export {
  RangeSlider as default
};
//# sourceMappingURL=RangeSlider.js.map
